export default __webpack_public_path__ + "static/group_color-11976dc63ade6df5e10c2bf24cefab1a.png";